import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.contest.$slug')

export const handle = {
  name: 'contest-detail',
  track: ({ params }: { params: Record<string, string | undefined> }) => ({
    scene: 'contest',
    section: params.id,
  }),
  showAppNav: true,
}

export function loader() {
  return null
}

export default dynamic(getClientModule, { ssr: false })
